import React from 'react';
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { Footer } from '../../Components/Footer/FooterComponent';
import { PagoEncuestaRedirectComponent } from '../../Components/Encuestas/PagoEncuestaRedirectComponent';

export const PagoEncuestaRedirectPage = (props) => (
  <>
    <LogoHeader I18n={props.I18n} />
    <NavDesktop I18n={props.I18n} />
    <NavMobile I18n={props.I18n} />
    <PagoEncuestaRedirectComponent />
    <Footer I18n={props.I18n} />
  </>
);
